import type { ScrapingJob } from '../api';
import { SCRAPING_JOB_STATUS, SCRAPING_JOB_TYPE } from '../types';

export const isCancelableScrapingJob = (scrapingJob: ScrapingJob) => {
  if (scrapingJob.type !== SCRAPING_JOB_TYPE.ONETIME) return false;
  return (
    scrapingJob.status === SCRAPING_JOB_STATUS.BEFORE_CONFIRM ||
    scrapingJob.status === SCRAPING_JOB_STATUS.RUNNING_SCRAPING ||
    scrapingJob.status === SCRAPING_JOB_STATUS.BEFORE_SCRAPING
  );
};

export const isDeletableScrapingJob = (scrapingJob: ScrapingJob) => {
  if (scrapingJob.type !== SCRAPING_JOB_TYPE.SCHEDULED) return false;
  return true;
};

export const isDeletableAllFeedbackScrapingJob = (scrapingJob: ScrapingJob) => {
  if (scrapingJob.type !== SCRAPING_JOB_TYPE.ONETIME) return false;
  return scrapingJob.status === SCRAPING_JOB_STATUS.COMPLETED;
};
